/**
 * OrbDocReferenceBehaviorsARDocScreenView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait OrbDocReferenceBehaviorsARDocScreen
 */

import { useOrbDocReferenceBehaviorsARDocScreenLogic } from '@/hooks/traits/useOrbDocReferenceBehaviorsARDocScreenLogic';
import type { OrbDocReferenceBehaviorsARDocScreenConfig } from '@/hooks/traits/useOrbDocReferenceBehaviorsARDocScreenLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { OrbDocReferenceBehaviorsARDocView as OrbDocReferenceBehaviorsARDocViewEntity } from '@app/shared';
import { OrbDocReferenceBehaviorsARDocBodyView } from '@/components/traits/OrbDocReferenceBehaviorsARDocBodyView';
import { OrbDocReferenceBehaviorsARDocFooterView } from '@/components/traits/OrbDocReferenceBehaviorsARDocFooterView';
import { OrbDocReferenceBehaviorsARDocHeaderView } from '@/components/traits/OrbDocReferenceBehaviorsARDocHeaderView';
import { Stack } from '@almadar/ui/components';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface OrbDocReferenceBehaviorsARDocScreenViewProps {
  config?: Partial<OrbDocReferenceBehaviorsARDocScreenConfig>;
}

export function OrbDocReferenceBehaviorsARDocScreenView({ config: propsConfig }: OrbDocReferenceBehaviorsARDocScreenViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useOrbDocReferenceBehaviorsARDocScreenLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['OrbDocReferenceBehaviorsARDocView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="OrbDocReferenceBehaviorsAR" trait="OrbDocReferenceBehaviorsARDocScreen">
      <UISlotComponent slot="main" pattern={slotWriter['main'] === 'INIT' ? "stack" : "clear"} sourceTrait="OrbDocReferenceBehaviorsARDocScreen">{slotWriter['main'] === 'INIT' ? (<Stack direction="vertical" gap="none"><OrbDocReferenceBehaviorsARDocHeaderView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><OrbDocReferenceBehaviorsARDocBodyView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><OrbDocReferenceBehaviorsARDocFooterView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack>) : null}</UISlotComponent>
    </TraitScopeProvider>
  );
}

export default OrbDocReferenceBehaviorsARDocScreenView;
